import angular from 'angular';
import stLocationComponent from './stLocation.component';
import translate from 'angular-translate';
import locationsApi from '../../api/locations/locations';

let stLocationModule = angular.module('stLocation', [
    translate,
    locationsApi
])
    .component('stLocation', stLocationComponent)
    .name;

export default stLocationModule;



// WEBPACK FOOTER //
// ./client/app/common/stLocation/stLocation.js